/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum OverlayAnimationTypeEnum {
    FADE = 'FADE',
    SLIDE = 'SLIDE',
    ZOOM = 'ZOOM',
}